import { FormControl, InputLabel, Select } from '@mui/material';
import { getFieldControlSx } from '../fieldStyles';
import type { FieldRendererProps } from '../types';

export function SelectField({
  field,
  className,
  sx,
  hasWhiteFields = false,
  isDisabled,
  isReadOnly,
  onChange,
}: FieldRendererProps) {
  return (
    <FormControl
      className={className}
      sx={getFieldControlSx(hasWhiteFields, sx)}
      variant="outlined"
      margin="dense"
      fullWidth
      required={field.required}
    >
      {field.value.length > 0 && <InputLabel id={`${field.id}-label`}>{field.label}</InputLabel>}
      <Select
        native
        readOnly={isReadOnly}
        labelId={`${field.id}-label`}
        id={field.id.toString()}
        label={field.label}
        value={field.value}
        disabled={isDisabled}
        onChange={(event) => onChange(event.target.value as string)}
        data-testid={field.id}
      >
        {field.selectOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </Select>
    </FormControl>
  );
}
